import { Tag } from '@digdir/designsystemet-react';
import React from 'react';

const SuccessTag = ({ label }: { label: string }) => (
  <Tag data-variant="outline" data-color="success">
    {label}
  </Tag>
);

const WarningTag = ({ label }: { label: string }) => (
  <Tag data-variant="outline" data-color="warning">
    {label}
  </Tag>
);

const InfoTag = ({ label }: { label: string }) => (
  <Tag data-variant="outline" data-color="info">
    {label}
  </Tag>
);

const DangerTag = ({ label }: { label: string }) => (
  <Tag data-variant="outline" data-color="danger">
    {label}
  </Tag>
);

export { SuccessTag, WarningTag, InfoTag, DangerTag };
